/**
 * @file ConsentTextsAccess.tsx
 * @description Доступ к разделу «Согласие на cookie» (phase19.16, Р3г;
 * uiux-r3g-consent-texts §5 «Нет права»): без `PLATFORM_MANAGE_PERSONAL_DATA`
 * пункта в меню нет, а по прямому адресу — понятный текст, какое право
 * нужно (вместо безликого перехода на /403). API всё равно отвечает 403.
 */

import { ShieldAlert } from "lucide-react";
import { Outlet } from "react-router";

import { useHasPermission } from "../../../auth/hooks";
import { CONSENT_TEXTS_PERMISSION } from "../../../lib/api-consent-texts";
import { EmptyState } from "../../ui/EmptyState";

export function ConsentTextsAccess() {
  const allowed = useHasPermission(CONSENT_TEXTS_PERMISSION);
  if (allowed) return <Outlet />;
  return (
    <EmptyState
      icon={ShieldAlert}
      variant="forbidden"
      title="Нужно право «Управление персональными данными»"
      description="Тексты согласия на cookie меняет платформенный администратор с этим правом."
    />
  );
}
